import { render, staticRenderFns } from "./SiteKeyboardLegend.vue?vue&type=template&id=04f0a8d7&scoped=true"
import script from "./SiteKeyboardLegend.vue?vue&type=script&lang=js"
export * from "./SiteKeyboardLegend.vue?vue&type=script&lang=js"
import style0 from "./SiteKeyboardLegend.vue?vue&type=style&index=0&id=04f0a8d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f0a8d7",
  null
  
)

export default component.exports